module.exports = __webpack_public_path__ + "img/face-frown-slight.0989b5e1.svg";